// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const Filter: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M3.12 7h8.28a2.002 2.002 0 0 0 2.74.725l-.009.005c.49-.293.84-.778.948-1.348l.002-.012h6.53a.381.381 0 0 0 .003-.75h-6.532a1.85 1.85 0 0 0-.225-.629l.005.009a2.002 2.002 0 0 0-3.455-.009L11.402 5h-8.28a1 1 0 0 0 0 2H3.12ZM3.12 13H18.4a2 2 0 1 0 .005-2.009L18.4 11H3.12a1 1 0 0 0 0 2ZM21.61 17.66H8.09A2.002 2.002 0 0 0 6.119 16h-.031.002c-.72.016-1.345.41-1.685.991L4.4 17H3.12a1 1 0 0 0 0 2H4.4a2 2 0 0 0 3.677-.577l.002-.013h13.53a.381.381 0 0 0 .003-.75h-.002Z" />
  </SvgIcon>
);

Filter.activeColor = 'inherit';
Filter.muiName = 'Filter';
